import {useEffect, useState} from 'react';
import {useSession} from 'next-auth/react';
import AthenaAPI from '../../APIs/AthenaAPI';
import {InternalUser} from '@amplify/athena-models';
import {ExtendedAgentData} from '../../UserAdmin/types';

export const useCurrentUserSettings = () => {
    const {data: session}: any = useSession();
    const [internalUser, setInternalUser] = useState<InternalUser | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchUserSettings = async () => {
            if (!session?.user?.email) {
                setLoading(false);
                return;
            }

            try {
                const user = await AthenaAPI.getInternalUser(session.user.email);
                setInternalUser(user);
                setError(null);
            } catch (err) {
                console.error('Failed to fetch user settings:', err);
                setError('Failed to fetch user settings');
                setInternalUser(null);
            } finally {
                setLoading(false);
            }
        };

        fetchUserSettings();
    }, [session?.user?.email]);

    const useMultiPagePrequal = (internalUser?.agentData as ExtendedAgentData)?.useMultiPagePrequal || false;

    return {
        internalUser,
        useMultiPagePrequal,
        loading,
        error,
    };
};
